const notifView = require('templates/notification.jst.jade')
const NotificationItem = {
  ui: {
    timestamp: ".publish-date"
  },

  resource: null,
  html: '',

  new(resource) {
    var object = Object.create(NotificationItem);
    object.resource = resource;
    object.render();
    object.bindRelativeTime();

    return object;
  },

  render() {
    this.html = $(notifView({ notification: this.resource }));
  },

  bindRelativeTime() {
    this.html.find(this.ui.timestamp).timeago();
  }
};

export default NotificationItem;
